// import { useForm } from 'react-hook-form'
// import { ReactComponent as DownArrow } from '../assets/icons/chevron-down.svg'
// import { ReactComponent as EmailAt } from '../assets/icons/email-at.svg'
// import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
// import ResetPasswordMain from '../components/ResetPasswordMain'
// import ResetPasswordCode from '../components/ResetPasswordCode'
// import ResetPasswordNull from '../components/ResetPasswordNull'
import ResetPasswordNew from '../components/ResetPasswordNew'

export default function ResetPasswordView() {
  return (
    <div className='wrapper'>
      <div className='contents-wrapper'>
        <div className='flex h-full w-full items-center justify-center'>
          {/* <ResetPasswordMain /> */}
          {/* <ResetPasswordCode /> */}
          {/* <ResetPasswordNull /> */}
          <ResetPasswordNew />
        </div>
      </div>
    </div>
  )
}
